import styles from "./Loader.module.scss";
import React from "react";

export const Loader = () => {
  return <div className={styles.loaderContainer}>
    <div className={styles.loader}></div>
  </div>;
};
